import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {
    deleteInquiry,
    getCurrentInquiry,
    resetDeleteInquiryStatus,
} from "../../store/reducers/InquiriesSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";

interface DeleteInquiryScreenProps {
}

export const DeleteInquiryScreen: React.FC<DeleteInquiryScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const inquiriesState = useAppSelector((state) => state.inquiries);
    const requestStatus: RequestStatus = inquiriesState.deleteInquiryStatus;

    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Päringud", url: "/inquiries"},
        {text: "Päringu kustutamine", url: `/inquiries/${id}/delete`},
    ];

    useEffect(() => {
        dispatch(resetDeleteInquiryStatus());
    }, [location]);

    const handleConfirm = () => {
        if (id) {
            dispatch(deleteInquiry(Number(id)));
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (id) {
            dispatch(getCurrentInquiry({ id: parseInt(id) }));
        }
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Päring kustutatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: "center"}}>
                <div>
                    <h2>
                        Oled kindel, et soovid päringu kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};